import { Component, Input } from '@angular/core';
import { ErzeugungsanlagenImportReport } from '../model/erzeugungsanlagen-import-report';

@Component({
    selector: 'redispatch-importreport-display',
    templateUrl: './import-report-display.component.html',
    styleUrls: [
        './import-report-display.component.scss',
    ],
    standalone: false,
})
export class ImportReportDisplayComponent {

    @Input()
    public erzeugungsanlagenImportReport: ErzeugungsanlagenImportReport;

    private static countTransformationLogType(report: ErzeugungsanlagenImportReport, logType: string, code: string = null) {
        let count = 0;
        if (report) {
            for (const log of report.transformations.flatMap(transformation => transformation.log)) {
                if (log.type === logType && (code == null || log.errorCode === code || log.warningCode === code)) {
                    count++;
                }
            }
        }
        return count;
    }

    private static countImportLogType(report: ErzeugungsanlagenImportReport, logType: string) {
        let count = 0;
        if (report) {
            for (const log of report.log) {
                if (log.type === logType) {
                    count++;
                }
            }
        }
        return count;
    }

    amountDeletions(): number {
        return (this.erzeugungsanlagenImportReport.delta?.amountOfDeletedErzeugungsanlagen || 0) +
            (this.erzeugungsanlagenImportReport.delta?.amountOfDeletedErzeugungsanlagenWithPlanwerten || 0);
    }

    getNumberOfWarnings(): number {
        return this.getNumberOfImportWarnings() + this.getNumberOfTransformationWarnings();
    }

    getNumberOfPlanwertWarnings(): number {
        return ImportReportDisplayComponent.countTransformationLogType(
            this.erzeugungsanlagenImportReport,
            'WarningTransformationLogItem',
            'PLANWERTE_WILL_BE_SET_TO_INVALID',
        );
    }

    areLogsPresent(): boolean {
        return (this.getNumberOfTransformationWarnings() > 0 ||
            this.getNumberOfTransformationErrors() > 0 ||
            this.getNumberOfImportErrors() > 0 ||
            this.getNumberOfImportWarnings() > 0);
    }

    // returns the total number of Warning within the transformations
    public getNumberOfTransformationWarnings(): number {
        return ImportReportDisplayComponent.countTransformationLogType(this.erzeugungsanlagenImportReport, 'WarningTransformationLogItem');
    }

    // returns the total number of Warning within the transformations (+ 1 only when the report contains a deletion delta)
    public getNumberOfTransformationWarningsPlusDeletions(): number {
        return this.getNumberOfTransformationWarnings() + this.amountDeletions();
    }

    // returns the total number of Errors within the transformations
    public getNumberOfTransformationErrors(): number {
        return ImportReportDisplayComponent.countTransformationLogType(this.erzeugungsanlagenImportReport, 'ErrorTransformationLogItem');
    }

    // returns the total number of Errors within the transformations
    public getNumberOfImportErrors(): number {
        return ImportReportDisplayComponent.countImportLogType(this.erzeugungsanlagenImportReport, 'ErrorImportLogItem');
    }

    // returns the total number of Errors within the transformations
    private getNumberOfImportWarnings(): number {
        return ImportReportDisplayComponent.countImportLogType(this.erzeugungsanlagenImportReport, 'WarningImportLogItem');
    }

}
